import React from 'react'
import { Children } from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

function AuthedUser({children}) {
    const isLoggedIn =useSelector(state=>state?.GlobalReducer?.token)
    const user =useSelector(state=>state.GlobalReducer?.user)
    if(user?.user_type=='admin' &&isLoggedIn){
      return <Navigate to='/'/>
    }
    if(!isLoggedIn){
      return <Navigate to='/login'/>
    }
    return children
}

export default AuthedUser